import type { StoryFunnel, StoryFunnelScreen } from "./_story-funnel-schema";

export const BOOST_STORY_EFFECTS = { confetti: true } satisfies NonNullable<StoryFunnel["effects"]>;

export const BOOST_STORY_PRODUCT_IMAGE = {
  src: "/static/images/offer-hero-boost-1112.webp",
  alt: "Mars Men Boost product artwork",
};

const BOOST_STORY_DISCLAIMER = "These statements have not been evaluated by the Food and Drug Administration. Mars Men products are not intended to diagnose, treat, cure, or prevent any disease. Individual results may vary. Results and timelines shown are illustrative and not guaranteed. Characters and lifestyle imagery on this page may include AI-generated depictions and dramatizations, not actual customers or testimonials. Customer reviews reflect individual experiences and may not represent typical results.";

/** Each authored story receives its own offer screen and destination setting. */
export function buildBoostStoryOffer(): StoryFunnelScreen {
  return {
    id: "offer",
    role: "offer",
    layout: "content-panel",
    artwork: "boost-offer",
    eyebrow: "EXCLUSIVE OFFER",
    heading: "50% FOR LIFE AND $100 IN FREE GIFTS",
    headingAccent: ["50% FOR LIFE", "FREE GIFTS"],
    blocks: [{ type: "benefits", items: [
      { icon: "guarantee", text: "90 Day Money Back Guarantee" },
      { icon: "shipping", text: "Fast & Free Shipping with 1st Order" },
    ] }],
    cta: "CLAIM OFFER \u2192",
    disclaimer: BOOST_STORY_DISCLAIMER,
  };
}
